import { Fragment } from 'react/jsx-runtime';

export default function List({ items = [], heading = false }) {
  return (
    <div className="List">
      {heading && <p className="headingStrong">{heading}</p>}
      <div className="List-items">
        {items.map((item, index) => (
          <Fragment key={index}>
            <hr />
            <div className="List-item">{item}</div>
          </Fragment>
        ))}
      </div>
    </div>
  );
}
